export const JUSTIFICATION_REGEX_TEXT = "^(.|\\n){30,99999}$";
export const JUSTIFICATION_REGEX = new RegExp(JUSTIFICATION_REGEX_TEXT);
export const CERT_SUBJECT_DN_REGEX_TEXT = "^[^=,]+[=][^,=]+(,[^=,]+[=][^=,]+){0,50}$";
export const CERT_SUBJECT_DN_REGEX = new RegExp(CERT_SUBJECT_DN_REGEX_TEXT);
export const CERT_SERIAL_NO_REGEX_TEXT = "^\\S+$";
export const CERT_SERIAL_NO_REGEX = new RegExp(CERT_SERIAL_NO_REGEX_TEXT);
export const REGEX_IDENTIFIER = /^[\w\s+=,.@-]+$/;
export const REGEX_IPS_TEXT = "^(\\s|\\n)*\\d+(\\.\\d+){3}([\\s]*(,|\\n)+\\s*\\d+(\\.\\d+){3})*$";
export const IP_V4_REGEX =
  /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
export const CREDENTIALS_REGEX = new RegExp("^/credentials/[^/]+$");
